import { render, staticRenderFns } from "./AssemblyInformation.vue?vue&type=template&id=5fc90284&"
import script from "./AssemblyInformation.vue?vue&type=script&lang=js&"
export * from "./AssemblyInformation.vue?vue&type=script&lang=js&"
import style0 from "./AssemblyInformation.vue?vue&type=style&index=0&id=5fc90284&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports